import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {TableModule} from "primeng/table";
import {FooterComponent} from "./component/footer/footer.component";
import {LayoutComponent} from "./component/layout/layout.component";
import {MenuComponent} from "./component/menu/menu.component";
import {SidebarComponent} from "./component/sidebar/sidebar.component";
import {TopbarComponent} from "./component/topbar/topbar.component";
import {HomePage} from "./page/home-page/home.page";
import {MenuItemComponent} from "./component/menu/menu-item.component";
import {ConfigComponent} from "./component/config/config.component";
import {CrossModule} from "../cross/cross.module";
import {ContractsPage} from "./page/contracts-page/contracts.page";
import {TabViewModule} from "primeng/tabview";
import {AvatarModule} from "primeng/avatar";
import {DropdownModule} from "primeng/dropdown";
import {SelectButtonModule} from "primeng/selectbutton";
import {DataViewModule} from "primeng/dataview";
import {MultiSelectModule} from "primeng/multiselect";
import {DividerModule} from "primeng/divider";
import {ChipModule} from "primeng/chip";
import {ObjectTypeImageDirective} from "../cross/contracts/directive/object-type-image.directive";
import {UserInsurancesComponent} from "./component/user-insurances/user-insurances.component";
import {MyContractsPage} from "./page/my-contracts-page/my-contracts.page";
import {ObModule} from "../ob/ob.module";
import {DocumentsPage} from "./page/documents-page/documents.page";
import {DocumentsComponent} from "./component/documents/documents.component";
import {ProgressSpinnerModule} from "primeng/progressspinner";

@NgModule({
  declarations: [
    FooterComponent,
    LayoutComponent,
    MenuComponent,
    SidebarComponent,
    TopbarComponent,
    MenuItemComponent,
    ConfigComponent,
    HomePage,
    ContractsPage,
    UserInsurancesComponent,
    MyContractsPage,
    DocumentsPage,
    DocumentsComponent,
  ],
  exports:[
    FooterComponent,
    LayoutComponent,
    MenuComponent,
    SidebarComponent,
    TopbarComponent,
    MenuItemComponent,
    ConfigComponent,
    HomePage,
    ContractsPage,
    UserInsurancesComponent,
    MyContractsPage,
    DocumentsPage,
    DocumentsComponent,
  ],
  imports: [
    CoreModule,
    CrossModule,
    TableModule,
    TabViewModule,
    AvatarModule,
    DropdownModule,
    SelectButtonModule,
    DataViewModule,
    MultiSelectModule,
    DividerModule,
    ChipModule,
    ObjectTypeImageDirective,
    ProgressSpinnerModule,
    ObModule
  ]
})
export class DsModule { }
